module.exports = __webpack_public_path__ + "f51f0b9d3c73ef5c2fb56208c54775e4.svg";